import AboutXpKnowMoreDialog from './AboutXpKnowMoreDialog';

const FALLBACK_CONTENT = {
  title: 'Know About XPs',
  sections: [
    {
      heading: 'What is XP',
      body:
        'XP (Experience Points) is a reward you earn by participating in a game. It tracks your progress and skill level, helping you unlock more XP.',
    },
    {
      heading: 'How to Earn XP',
      body:
        'You can earn XP by completing games, joining contests, winning rounds or staying active daily. The more you engage and perform well, the more XP you gain.',
    },
    {
      heading: 'How to Redeem XP',
      body:
        'XP can be redeemed for coupons on RapBazaar. Simply go to the Coins Wallet, then the XP section, and click the button to use your accumulated XP and convert it to RapCoins.',
    },
    {
      heading: 'XPs Expiration',
      body:
        "XP has a 7 day validity period and can expire if not used within this time period. Make sure to check the expiry details and redeem your XP before the deadline. Staying active and regularly using your XP ensures you don't lose your earned rewards.",
    },
  ],
};

/** Figma 11051:14224–14890 — Know About XPs dialog */
export default function XpKnowMoreDialog({ open, onClose }) {
  return <AboutXpKnowMoreDialog open={open} onClose={onClose} slug="xp" fallbackContent={FALLBACK_CONTENT} />;
}
